import React from 'react';
import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown';
import {useTranslation} from "react-i18next";
import AdminFieldLabel from './AdminFieldLabel';
import {range} from 'lodash';

interface AdminInputYearProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  name: string;
  id: string;
  className?: string;
  error?: string;
  minYear?: number;
  maxYear?: number;
}

const AdminInputYear: React.FC<AdminInputYearProps> = ({
                                                         label,
                                                         value,
                                                         onChange,
                                                         placeholder,
                                                         required = false,
                                                         name,
                                                         id,
                                                         className = '',
                                                         error,
                                                         minYear = 2000,
                                                         maxYear = new Date().getFullYear()
                                                       }) => {
  const {t} = useTranslation();
  const defaultPlaceholder = t('admin.common.dropdowns.selectOption');

  const yearOptions = range(maxYear, minYear - 1, -1).map(year => ({
    value: String(year),
    label: String(year)
  }));

  // Extract year from YYYY-MM-DD format for display
  const displayValue = value ? value.substring(0, 4) : null;

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    // Convert year to YYYY-01-01 format for backend
    const dateValue = e.value ? `${e.value}-01-01` : '';
    const syntheticEvent = {
      target: {
        name: name,
        value: dateValue
      }
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(syntheticEvent);
  };

  return (
    <div className={className}>
      <AdminFieldLabel htmlFor={id} label={label} required={required}/>
      <Dropdown
        id={id}
        name={name}
        value={displayValue}
        options={yearOptions}
        onChange={handleDropdownChange}
        optionLabel="label"
        optionValue="value"
        placeholder={placeholder || defaultPlaceholder}
        className={`w-full px-2 py-1 border rounded-sm focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-transparent transition duration-300 ${error ? 'border-red-500' : 'border-gray-300'}`}
        showClear={!required}
      />
      {error && <small className="block text-red-500 text-xs mt-1">{error}</small>}
    </div>
  );
};

export default AdminInputYear;

